// extracted by mini-css-extract-plugin
export var layoutContainer = "_8q-0";
export var layoutContainerNoRounding = "_8q-6";
export var layoutContainerOpen = "_8q-5";
export var layoutContainerResizing = "_8q-1";
export var mainContent = "_8q-2";
export var resizeDivider = "_8q-3";
export var slidePanel = "_8q-4";